import { TooltipIcon } from "@solomon-labs/design/components/icons";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger
} from "@solomon-labs/design/components/ui";
import React from "react";

/**
 * The small info tooltip beside a label: the reason or definition behind a
 * figure, on demand. Same shape as the issuer console's `HintTip`, so the
 * two consoles teach the reader one signal.
 */
export function HintTip({
    text,
    label
}: {
    text: string;
    /** Accessible name for the trigger, e.g. "About Historical APY". */
    label: string;
}): React.ReactElement {
    return (
        <TooltipProvider>
            <Tooltip>
                {/* tabIndex keeps the hint keyboard-reachable: Base UI's
                    TooltipTrigger relies on a natively focusable element, and
                    rendering a <span> drops that. */}
                <TooltipTrigger
                    tabIndex={0}
                    aria-label={label}
                    render={
                        <span className="inline-flex shrink-0 cursor-help text-foreground-neutral hover:text-foreground-base" />
                    }
                >
                    <TooltipIcon className="size-4" />
                </TooltipTrigger>
                <TooltipContent side="top">{text}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
